import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
export const CelebrityCardSkeleton: FC<{
  className?: string;
}> = t0 => {
  const $ = _c(4);
  const {
    className
  } = t0;
  const t1 = `flex flex-col p-1.5 lg:p-2 relative aspect-[168/216] lg:aspect-[288/352] w-full overflow-hidden rounded-[16px] bg-[#31324B59] lg:rounded-[20px] animate-pulse ${className}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="min-h-[44px] lg:min-h-[58px] lg:mb-1.5 px-2 py-1.5 flex flex-col gap-1"><div className="h-4 lg:h-5 w-3/4 rounded bg-white/20" /><div className="h-4 lg:h-5 w-1/2 rounded bg-white/20" /></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="relative flex-1 mt-auto rounded-[12px] lg:rounded-[16px] overflow-hidden bg-white/10"><div className="absolute bottom-1 lg:bottom-0 left-0 right-0 flex items-center justify-between px-2"><div className="flex flex-col gap-0.5 lg:p-1"><div className="h-3 lg:h-4 w-20 lg:w-28 rounded bg-white/20" /><div className="h-3 lg:h-4 w-20 lg:w-28 rounded bg-white/20" /></div><div className="w-[32px] h-[32px] lg:w-[56px] lg:h-[56px] rounded-full bg-white/10" /></div></div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[2] = t1;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};